import React from "react";
import styled from "styled-components";

import { DataLoadingLayout } from "common/utils/DataLoadingLayout";
import {
  SIDEBAR_WIDTH,
  SIDEBAR_WIDTH_EXPANDED,
  sideBarProfileSize,
  defaultAnimationDuration,
} from "common/const/const";
import { ImagePreview } from "common/components/Button/new/ImagePreview";
import { TextButton2, TextMenu, TextTitle4 } from "common/components";
import { colors } from "common/const/colors";

const SideBarProfileLayout = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  box-sizing: border-box;
  width: ${({ $isOpen }) => ($isOpen ? SIDEBAR_WIDTH_EXPANDED : SIDEBAR_WIDTH)};
  padding: 1.25rem 1rem;
  border-bottom: 0.5px solid var(--Gray);
  transition:
    width ${defaultAnimationDuration} ease-in-out,
    padding ${defaultAnimationDuration} ease-in-out;
`;

const SideBarProfileButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  transition: ${defaultAnimationDuration} ease-in-out;
`;

const ProfileImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${sideBarProfileSize};
  height: ${sideBarProfileSize};
  border-radius: 0.5rem;
  overflow: hidden;
  transition: all ${defaultAnimationDuration} ease-in-out;
`;

const SideBarProfileField = ({ isOpen, clubImageRef, roleName, clubName }) => {
  const isVideo =
    clubImageRef?.includes(".mp4") || clubImageRef?.includes(".mov");

  return (
    <SideBarProfileLayout $isOpen={isOpen}>
      <SideBarProfileButton $isOpen={isOpen}>
        <DataLoadingLayout loading={!clubImageRef}>
          <ProfileImageWrapper $isOpen={isOpen}>
            <ImagePreview
              width={"100%"}
              height={"100%"}
              src={clubImageRef}
              isVideo={isVideo}
              alt="profile"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </ProfileImageWrapper>
        </DataLoadingLayout>
      </SideBarProfileButton>
      <SideBarProfileInfo $isOpen={isOpen}>
        <InfoInner>
          <DataLoadingLayout loading={!roleName || !clubName}>
            <TextButton2>{clubName}</TextButton2>
            <TextMenu style={{ color: colors.LightNavy }}>{roleName}</TextMenu>
          </DataLoadingLayout>
        </InfoInner>
      </SideBarProfileInfo>
    </SideBarProfileLayout>
  );
};

const SideBarProfileInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
  min-width: 0;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  max-width: ${({ $isOpen }) => ($isOpen ? "15rem" : "0")};
  transition:
    opacity ${defaultAnimationDuration} ease,
    max-width ${defaultAnimationDuration} ease;
`;

const InfoInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 15rem;
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: break-word;
`;

export default SideBarProfileField;
